import React from 'react';
import RenderAttributeInput, { AttributeFieldProps } from './RenderAttributeInput';
import GetAttributeDefinition, { AttributeInputType } from '../Data/WBData';

export default function RenderModularInput(props:AttributeFieldProps&{onDelete:Function}){




if(props.definition.inputType == AttributeInputType.Ignore)
    return null;

    return <div className ="modular-att-input">
    <button className='invisible-button modular-delete-button'
    
    onClick={()=>{

      
        props.updateFunc(props.definition.attKey,"",props.definition.targetType);

        for(let i = 0;i<props.definition.group.length;i++){
            let def = GetAttributeDefinition(props.definition.group[i]);

            props.updateFunc(props.definition.group[i],"",def.targetType);
        }

        props.onDelete(props.definition.attribute);
      
    }}

    >&times;</button>
        <RenderAttributeInput  {...props}/>
    </div>
}